import axios from 'axios'

export const loadCategories = (event, type = 'user', bday = '', gender = '') =>
    axios.get(`inscription/get_categories/?event=${event}&type=${type}&bday=${bday}&gender=${gender}`)

export const loadPrices = (category, event, type = '') =>
    axios.get(`inscription/get_values/${category}/${event}/${type}`)

export const loadAdditionals = (event, category) =>
    axios.get(`inscription/get_additional/?event=${event}&category=${category}`)

export const loadExtras = (event) =>
    axios.get(`events/extras/${event}`)

export const loadDrafts = (event, type = '') =>
    axios.get(`inscription/get_draft/${event}/${type}`)

export const loadAthletes = (token) =>
    axios.get(`inscription/get_users/${token}/`)

export const create = (event, type = 'me', action = 'create', data = {}) => {
    return axios.post(`inscription/create/${event}/${type}/${action}`, data)
}

export const invite = (email, inscription_token, category_id, event_token) =>
    axios.post(`inscription/invite`, {
        email,
        inscription_token,
        category_id,
        event_token
    })

export const deleteInvite = (id, inscription_token) =>
    axios.get(`inscription/delete_invite/${id}/${inscription_token}`)

export const invitations = (event) => 
    axios.get(`inscription/invitations/${event}`)

export const getInvites = (inscription_token) =>
    axios.get(`inscription/get_invitations/${inscription_token}`)

export const myInscriptions = () =>
    axios.get(`inscription/all_inscriptions`)

export const loadGroupsInscriptions = () =>
    axios.get(`inscription_groups/list_groups`)

export const cloneGroupInscription = ( id, eventToken ) =>
    axios.post(`inscription_groups/clone_group/${id}`, {
        event_token: eventToken
    })



// WEBPACK FOOTER //
// ./src/utils/inscription.js